<template>
  <div>
    <ClientInvoice v-if="$getConstRole('ROLE_CLIENT') == role"></ClientInvoice>
    <AgentInvoice v-if="$getConstRole('ROLE_AGENT') == role"></AgentInvoice>
    <AccountantInvoice v-if="$getConstRole('ROLE_ACCOUNTING') == role"></AccountantInvoice>
    <AdminInvoice v-if="$getConstRole('ROLE_ADMIN') == role"></AdminInvoice>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ClientInvoice from '@/views/client/invoice/View.vue'
import AgentInvoice from '@/views/agent/invoice/View.vue'
import AccountantInvoice from '@/views/accountant/InvoiceView.vue'
import AdminInvoice from '@/views/admin/invoices/InvoiceView.vue'

export default {
  name: 'invoiceView',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    AccountantInvoice,
    ClientInvoice,
    AdminInvoice,
    AgentInvoice
  },
};
</script>
